import { type FC } from "react";
import * as styles from "./styles.css";

type EmploymentAndSalaryTypeProps = {
  employmentName: string;
  salaryMin: string;
  salaryMinUnit: string;
  salaryMax: string;
  salaryMaxUnit: string;
  salaryTypeName: string;
};

type Props = {
  employmentAndSalaryType: EmploymentAndSalaryTypeProps[];
  shopName?: string;
};

export const Salaries: FC<Props> = ({ employmentAndSalaryType, shopName }) => {
  return (
    <ul className={styles.container}>
      {employmentAndSalaryType.map((employment) => {
        return (
          <li
            key={`${shopName}${employment.employmentName}${employment.salaryTypeName}${employment.salaryMin}${employment.salaryMax}`}
            className={styles.salaryList}
          >
            <span className={styles.salaryEmploymentIconText}>{employment.employmentName}</span>
            <span className={styles.salaryEmploymentTypeText}>{employment.salaryTypeName}</span>
            <span className={styles.salaryNum}>
              {employment.salaryMin && (
                <>
                  <b>{employment.salaryMin}</b>
                  {employment.salaryMinUnit}
                </>
              )}
              {(employment.salaryMin || employment.salaryMax) && (
                <span className={styles.dash}>~</span>
              )}
              {employment.salaryMax && (
                <>
                  <b>{employment.salaryMax}</b>
                  {employment.salaryMaxUnit}
                </>
              )}
            </span>
          </li>
        );
      })}
    </ul>
  );
};
